"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("../../classnames"));
var Cheer_1 = __importDefault(require("../Cheer"));
var CheerButton = function (_a) {
    var _b = _a.cheered, cheered = _b === void 0 ? false : _b, className = _a.className, name = _a.name, onCheerToggle = _a.onCheerToggle, _c = _a.small, small = _c === void 0 ? false : _c;
    var _d = react_1.useState(false), toggling = _d[0], setToggling = _d[1];
    var _e = react_1.useState(false), touched = _e[0], setTouched = _e[1];
    var onClick = function () {
        setToggling(true);
        setTouched(true);
        onCheerToggle(!cheered).then(function () { return setToggling(false); });
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { type: "button", className: classnames_1.default("chq-cbn", className, {
                "chq-cbn-ch": cheered,
                "chq-cbn-sm": small
            }), disabled: toggling, onClick: onClick },
            react_1.default.createElement(Cheer_1.default, null),
            !small && react_1.default.createElement(react_1.default.Fragment, null,
                " ",
                "Cheer!")),
        cheered && react_1.default.createElement(Cheer_1.default, { name: name, small: small, pop: touched })));
};
exports.default = CheerButton;
